<template>
  <v-container >

    <service-order-view :defect-report-d-t-o="serviceDTO.relatedDefectReportDTO"
                        :planned-service-d-t-o="serviceDTO.relatedPlannedServiceDTO"
                        class="mb-5"/>

    <entity-properties-row :label="$t('service.doneDate')"
                           :property="service.doneDate | date"/>

    <entity-properties-row :label="$t('service.description')">
      <preformatted-text-view :value="service.description"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('service.installedParts')">
      <part-quantities-view v-model="service.installedParts"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('service.doneByUsers')">
      <table>
        <tbody>
        <tr v-for="doneBy in service.doneByUsers" :key="doneBy.id">
          <td class="pr-3">{{doneBy.worker | user}}</td>
          <td class="pr-3">{{doneBy.workDate | date}}</td>
          <td class="right">{{doneBy.workDuration | duration}}</td>
        </tr>
        </tbody>
      </table>
    </entity-properties-row>

    <entity-properties-row :label="$t('service.totalDuration')"
                           :property="service.durationMinutes | duration"/>


    <entity-properties-row :label="$t('service.expenses')">
      <table>
        <tbody>
          <tr v-for="expense in service.expenses" :key="expense.id">
            <td class="pr-3">{{expense.name}}</td>
            <td class="right">{{expense.cost}} {{$t('common.moneyUnit')}}</td>
          </tr>
        </tbody>

      </table>

    </entity-properties-row>

    <entity-properties-row :label="$t('service.documents')">
      <document-list :documents="serviceDTO.documents"/>
    </entity-properties-row>


    <entity-properties-row v-if="service.defectReport"
                           :label="$t('service.defectReportStatus')"
                           :property="service.defectReport.status | defectReportStatus"/>


    <entity-properties-row :label="$t('service.serviceState')"
                           :property="service.serviceState | serviceState"/>

    <entity-properties-row :label="$t('service.cleanedCheckedAccepted')"
                           :property="service.cleanedCheckedAccepted | yesNo"/>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import DocumentList from '@/components/layouts/DocumentList';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';
import ServiceOrderView from '@/views/service/ServiceOrderView';
import PartQuantitiesView from '@/components/layouts/PartQuantitiesView';

export default {
  name: 'ServicePropertiesView',
  components: { PartQuantitiesView, ServiceOrderView, PreformattedTextView, EntityPropertiesRow, DocumentList },
  props:{
    serviceDTO: {
      required:true,
      type: Object,
    },
  },
  computed: {

    service(){
      return this.serviceDTO.service;
    },
  },
};
</script>

<style scoped>

</style>
